// Estimativa de encoding e segmentos cobrados de um SMS.
//
// Espelha backend/src/services/SmsServices/SmsConnectionConfig.ts. Frontend e
// backend são pacotes separados sem módulo compartilhado, então as duas cópias
// precisam ser alteradas juntas.

// GSM 03.38 — alfabeto básico. Caracteres fora desta tabela forçam UCS-2.
const GSM7_BASIC =
  "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?" +
  "¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà";

// Caracteres da tabela de extensão: válidos em GSM-7, mas ocupam 2 posições.
const GSM7_EXTENDED = "^{}\\[~]|€";

export const estimateSmsSegments = (text) => {
  const value = String(text || "");

  let units = 0;
  let isGsm7 = true;

  for (const char of value) {
    if (GSM7_BASIC.includes(char)) {
      units += 1;
    } else if (GSM7_EXTENDED.includes(char)) {
      units += 2;
    } else {
      isGsm7 = false;
      break;
    }
  }

  if (!isGsm7) {
    const length = [...value].length;
    const charsPerSegment = length <= 70 ? 70 : 67;
    return {
      encoding: "UCS-2",
      length,
      segments: length === 0 ? 0 : Math.ceil(length / charsPerSegment),
      charsPerSegment,
    };
  }

  const charsPerSegment = units <= 160 ? 160 : 153;
  return {
    encoding: "GSM-7",
    length: units,
    segments: units === 0 ? 0 : Math.ceil(units / charsPerSegment),
    charsPerSegment,
  };
};

// ===== Regras específicas dos provedores de menor escala =====

/** Limite rígido do SMS Barato: sem concatenação de segmentos. */
export const SMSBARATO_MAX_LENGTH = 160;

/**
 * Converte caracteres acentuados no equivalente sem acento (ã→a, ç→c).
 * Usado pelo SMS Barato e pelo SMSDev, por motivos diferentes: o primeiro
 * rejeita acentos explicitamente, o segundo os translitera por conta própria.
 */
export const stripSmsDiacritics = (text) =>
  String(text || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

/** SMS Barato: sem acentos, sem quebras de linha (viram espaço). */
export const sanitizeSmsBaratoText = (body) =>
  stripSmsDiacritics(String(body || ""))
    .replace(/\r?\n/g, " ")
    .replace(/ {2,}/g, " ")
    .trim();

/**
 * SMSDev: o gateway translitera acentos antes de entregar, então a conversão é
 * feita no envio para que a prévia e a contagem batam com o SMS recebido. As
 * quebras de linha são preservadas. Espelha sanitizeSmsDevText do backend — lá
 * a composição inclui stripCampaignZwnj, que aqui não faz sentido: o U+200C só
 * é adicionado quando a campanha gera os shippings.
 */
export const sanitizeSmsDevText = (body) =>
  stripSmsDiacritics(String(body || "")).trim();

export default estimateSmsSegments;
